import React from "react";
import {
  Box

} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";

const LoadingContent = ({removeBg}) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
      sx={{
        boxShadow: removeBg && 'none!important',
        backgroundColor: removeBg && 'transparent!important',
      }}
    >
      <div className={classes.spinner}>
        <div className="--content">
          <svg className="--logo" width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style={{mixBlendMode: 'overlay'}}>
              <path d="M13.6238 0.464905C14.7707 -0.154968 16.1707 -0.154968 17.3176 0.464905L21.3114 2.62356C22.3363 3.17753 22.3363 4.59613 21.3114 5.15012L9.53901 11.5131C8.53405 12.0562 7.29272 11.3581 7.29272 10.2498V6.00632C7.29272 4.69711 8.02738 3.48974 9.21444 2.84814L13.6238 0.464905Z" fill="white"/>
              <path d="M44.301 0.464905C43.1541 -0.154968 41.7541 -0.154968 40.6072 0.464905L36.6134 2.62356C35.5885 3.17753 35.5885 4.59613 36.6134 5.15012L48.3858 11.5131C49.3906 12.0562 50.6319 11.3581 50.6319 10.2498V6.00632C50.6319 4.69711 49.8972 3.48974 48.7102 2.84814L44.301 0.464905Z" fill="white"/>
              <path d="M24.8544 5.02833C27.4198 3.60449 30.5803 3.60449 33.1454 5.02833L49.8546 14.3028C52.4199 15.7266 54 18.3581 54 21.2058V39.7547C54 42.6024 52.4199 45.2338 49.8546 46.6577L33.1454 55.932C30.5803 57.356 27.4198 57.356 24.8544 55.932L8.14532 46.6577C5.58018 45.2338 4 42.6024 4 39.7547V21.2058C4 18.3581 5.58018 15.7266 8.14532 14.3028L24.8544 5.02833ZM29.5245 43.368C29.2415 43.1331 28.8219 43.1333 28.5391 43.3682L23.6779 47.4063C23.2455 47.7656 23.3794 48.4264 23.947 48.4921C24.1549 48.5162 24.3656 48.5284 24.5782 48.5284H33.4095C33.6478 48.5284 33.8838 48.5132 34.1161 48.4829C34.679 48.4099 34.8076 47.7527 34.3777 47.3959L29.5245 43.368ZM24.5782 23.3015C22.6831 23.3015 20.9337 24.2786 19.995 25.8613L15.5226 33.4024C14.5991 34.9597 14.5989 36.8701 15.5226 38.4275L19.995 45.9686C20.2339 46.3712 20.525 46.7348 20.8577 47.0527C21.1133 47.297 21.5193 47.2841 21.7921 47.0577L28.0169 41.8869C28.1826 41.7492 28.2778 41.549 28.2778 41.3386V37.1824C28.2778 37.0554 28.243 36.9304 28.1767 36.8202L24.5325 30.7521C23.7204 29.3993 24.7357 27.7086 26.3603 27.7086H31.7781C33.4027 27.7086 34.418 29.3993 33.6059 30.7521L29.9615 36.8202C29.8955 36.9304 29.8606 37.0554 29.8606 37.1824V41.4009C29.8606 41.6116 29.956 41.8117 30.1218 41.9494L36.2333 47.0214C36.5083 47.2495 36.918 47.2604 37.1726 47.0115C37.4877 46.7032 37.7642 46.3539 37.9927 45.9686L42.4653 38.4275C43.3889 36.8701 43.3889 34.9597 42.4653 33.4024L37.9927 25.8613C37.054 24.2786 35.3046 23.3015 33.4095 23.3015H24.5782ZM18.8247 18.8139C17.9088 18.8139 17.1667 19.5276 17.1667 20.4081C17.1667 21.2885 17.9088 22.0022 18.8247 22.0022C19.7404 22.0022 20.4829 21.2885 20.4829 20.4081C20.4829 19.5276 19.7404 18.8139 18.8247 18.8139ZM39.2501 18.8139C38.3343 18.8139 37.5919 19.5276 37.5919 20.4081C37.5919 21.2885 38.3343 22.0022 39.2501 22.0022C40.1658 22.0022 40.9083 21.2885 40.9083 20.4081C40.9083 19.5276 40.1658 18.8139 39.2501 18.8139Z" fill="white"/>
            </g>
          </svg>
        </div>
      </div>
    </Box>
  )
}
const useStyles = makeStyles(() => ({
  '@keyframes rotateWithWobble': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
  root: {
    height: 320,
    zIndex: "1",
    display: "flex",
    margin: "14px 0",
    position: "relative",
    alignItems: "center",
    borderRadius: "16px",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "#0F191F",
    boxShadow: "0px -8px 24px 0px #0000003D",
},
  spinner: {
    zIndex: "0",
    padding: "7px",
    boxSizing: "border-box",
    borderRadius: "100%",
    position: "relative",
    width: "118px",
    height: "118px",
    border: "2px solid #ED752EB2",
    boxShadow: "none",

    "& .--content": {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      position: 'relative',
      zIndex: 0,

      '&:after': {
        content: '""',
        zIndex: 2,
        top: 0,
        left: 0,
        position: 'absolute',
        borderRadius: '100%',
        pointerEvents: 'none',
        width: '100%',
        height: '100%',
        animation: '$rotateWithWobble 1.5s infinite ease-in-out',
        background: 'conic-gradient(from 0deg at 50% 50%, rgba(0,0,0,0) 0deg, #ED752E 360deg)',
      }
    },
    "& .--logo": {
      zIndex: 3,
      width: '58px',
      height: '58px',
      position: 'relative',
      objectFit: 'contain',
      objectPosition: 'center',
    }
  }
}));
export default LoadingContent
